<template>
  <div class="page-container" ref="pageContainer">
    <img src="../assets/banner.png" alt="Banner Image" class="top-image">
    <div class="content-container">
      <blockquote class="el-blockquote">
        信用报告查询网点导航
      </blockquote>
      <div class="navigate-image-div">
        <router-link to="/navigate" class="image-link" @click="setActiveNavItem('/navigate')">
          <img src="../assets/navigate.png" alt="Navigate Image" class="navigate-image">
        </router-link>
      </div>
      <blockquote class="el-blockquote">
        信用报告查询渠道
      </blockquote>
      <div class="white-background">
          <div>
            <el-row>
              <el-col :span="12">
                <router-link to="/perQuery" class="image-link">
                  <img src="../assets/per_query.png" alt="Image 2" class="centered-image">
                </router-link>
              </el-col>
              <el-col :span="12">
                <router-link to="/entQuery" class="image-link">
                  <img src="../assets/ent_query.png" alt="Image 3" class="centered-image">
                </router-link>
              </el-col>
            </el-row>
          </div>
      </div>
      <div @click="handleScreenClick">
        <div class="tip-container">
          <blockquote class="el-blockquote tip-title">
            温馨提示
          </blockquote>
<!--          <router-link to="/questionAnswer" class="tip-action-button">-->
<!--            <img src="../assets/icon_robot.png" alt="Chat" class="tip-chat-icon">-->
<!--            <span class="tip-vertical-text">问一问</span>-->
<!--          </router-link>-->
        </div>
        <div class="content">
          <p class="content-text-indent">1.征信查询请务必本人办理或合法授权代理，切勿交陌生人代办，请妥善保存好自身的信用报告，提高警惕，谨防诈骗。</p>
          <p class="content-text-indent">2.港澳台同胞请进入“网点查询”，选择“港澳台证件查询”查询网点，就近办理个人信用报告查询业务。支持证件类型包括：港澳居民来往内地通行证，台湾同胞来往内地通行证，港澳台居住证。</p>
          <p class="content-text-indent">3.工商银行、建设银行、邮储银行智慧柜员机支持个人信用报告(简版）和企业信用报告查询，查得的企业信用报告与人民银行征信窗口内容一致。</p>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="isNoticeDialogVisible"
      @close="isNoticeDialogVisible = false"
      width="90%"
    >
      <div class="dialog-content">
        <div v-for="(item, index) in notices" :key="index">
          <h4 class="notice-title" v-html="item.title || ''"></h4>
          <div v-html="item.content || ''"></div>
        </div>
      </div>
      <div class="divider"></div>
      <span slot="footer">
          <el-button class="confirm-button" @click="isNoticeDialogVisible = false" size="small">
             确定
          </el-button>
        </span>
    </el-dialog>
    <transition name="slide-up">
      <div v-if="showFontSizeOptions" class="font-size-options">
        <div class="font-size-label">字体设置：</div>
        <div class="font-size-options-row">
          <div v-for="size in fontSizeOptions" :key="size"
               :class="{'font-size-option': true, 'selected': selectedFontSize === size}"
               @click="changeFontSize(size)">
            {{ size }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'
export default {
  created () {
    const hasVisited = sessionStorage.getItem('hasVisited')

    if (!hasVisited) {
      this.getNotice()
      sessionStorage.setItem('hasVisited', true)
    }
    window.addEventListener('beforeunload', this.clearSession)
  },
  data () {
    return {
      isNoticeDialogVisible: false,
      notices: [],
      showFontSizeOptions: false,
      selectedFontSize: '小',
      fontSizeOptions: ['小', '中', '大']
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.clearSession)
    window.removeEventListener('resize', this.checkAndroidNavigationBar)
  },
  methods: {
    ...mapMutations(['setActiveNavItem']),
    getNotice () {
      axios.post(this.$config.baseUrl + '/appointment-web/noticeController/getNotice')
        .then(response => {
          this.notices = response.data.notice
          if (this.notices.length > 0) {
            this.isNoticeDialogVisible = true
          }
        })
        .catch(error => {
          console.error('Error sending POST request:', error)
        })
    },
    clearSession () {
      sessionStorage.removeItem('hasVisited')
    },
    checkAndroidNavigationBar () {
      const pageContainer = this.$refs.pageContainer
      const isAndroid = /android/i.test(navigator.userAgent)
      const hasNavigationBar = window.innerHeight !== screen.height

      if (isAndroid && hasNavigationBar) {
        const navigationBarHeight = window.innerHeight - screen.availHeight
        const newHeight = window.innerHeight - navigationBarHeight

        pageContainer.querySelector('.content-container').style.height = `${newHeight}px`
      } else {
        pageContainer.querySelector('.content-container').style.height = '75%'
      }
    },
    handleScreenClick (event) {
      // 检查点击的目标是否是字体设置抽屉中的元素
      const clickedElement = event.target
      const isInDrawer = clickedElement.closest('.font-size-options')

      // 如果点击的是字体设置选项或复制链接，则不切换抽屉显示状态
      if (isInDrawer || clickedElement.classList.contains('copy-link')) {
        return
      }

      // 切换字体设置抽屉的显示状态
      this.showFontSizeOptions = !this.showFontSizeOptions
    },
    changeFontSize (size) {
      this.selectedFontSize = size
      document.documentElement.style.setProperty('--home-title-font-size', this.getTitleFontSize(size))
      document.documentElement.style.setProperty('--home-font-size', this.getFontSize(size))
      document.documentElement.style.setProperty('--home-height', this.getHomeHeight(size))
      document.documentElement.style.setProperty('--line-height', this.getLineHeight(size))
      // 保存字体设置到 localStorage
      localStorage.setItem('fontSize', size)
    },
    getTitleFontSize (size) {
      switch (size) {
        case '小':
          return '14px'
        case '中':
          return '16px'
        case '大':
          return '18px'
        default:
          return '14px'
      }
    },
    getFontSize (size) {
      switch (size) {
        case '小':
          return '13px'
        case '中':
          return '15px'
        case '大':
          return '17px'
        default:
          return '13px'
      }
    },
    getLineHeight (size) {
      switch (size) {
        case '小':
          return '1.6'
        case '中':
          return '1.8'
        case '大':
          return '2.0'
        default:
          return '1.6'
      }
    },
    getHomeHeight (size) {
      switch (size) {
        case '小':
          return '3%'
        case '中':
          return '4%'
        case '大':
          return '5%'
        default:
          return '3%'
      }
    }
  },
  mounted () {
    this.checkAndroidNavigationBar()
    window.addEventListener('resize', this.checkAndroidNavigationBar)
    // 初始化字体设置
    const savedFontSize = localStorage.getItem('fontSize') || '中'
    this.selectedFontSize = savedFontSize
    document.documentElement.style.setProperty('--home-title-font-size', this.getTitleFontSize(savedFontSize))
    document.documentElement.style.setProperty('--home-font-size', this.getFontSize(savedFontSize))
    document.documentElement.style.setProperty('--home-height', this.getHomeHeight(savedFontSize))
    document.documentElement.style.setProperty('--line-height', this.getLineHeight(savedFontSize))
  }
}
</script>

<style scoped>
:root {
  --home-title-font-size: 14px;
  --home-font-size: 13px;
  --home-height: 3%;
  --font-size: 16px;
  --line-height: 1.6;
}

.page-container {
  position: relative;
  background-color: #f5f5f5;
  height: 100%;
}

.top-image {
  width: 96%;
  border-radius: 10px;
  margin: 2% 2% 0 2%;
  height: 20%;
}

.el-blockquote {
  border-left: 3px solid;
  border-image: linear-gradient(to bottom, #357bf0, #6a9ef4);
  border-image-slice: 1;
  margin: 5px 0 0 15px;
  font-size: var(--home-title-font-size, 14px);
  padding-left:10px;
  text-align: left;
  text-decoration: none;
  color: black;
  font-weight: bold;
  height: var(--home-height, 3%);
}

.image-link {
  text-decoration: none;
  outline: none;
  border: none;
  -webkit-tap-highlight-color: transparent;
}

.centered-image {
  display: block;
  margin: 0 auto;
  width: 70%;
  padding-top: 10%;
  padding-bottom: 10%;
  border-radius: 10px;
}

.navigate-image-div {
  padding: 5px 0 5px 0;
}

.navigate-image {
  max-width: 100%;
  width: 96%;
  display: block;
  margin: 0 auto;
}

.content {
  margin: 10px 25px 0 25px;
}

.content-text-indent {
  text-indent: 2em;
  font-size: var(--home-font-size, 13px);
  margin: 2px 0 0 0;
  color: black;
  line-height: var(--line-height, 1.6);
}

.notice-title {
  text-align: center;
}

::v-deep .el-dialog__body {
  padding: 0 20px 10px 20px !important;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid blue;
  margin: 0 20px;
  padding: 40px 0 10px 0;
}

.dialog-content {
  height: 400px;
}

::v-deep .el-dialog__footer {
  text-align: center !important;
}

.confirm-button {
  color: blue;
}

.white-background {
  position: relative;
  background-color: #ffffff;
  border-radius: 10px;
  margin: 2%;
}

.content-container {
  width: 100%;
  height: 75%;
}

.divider {
  height: 1px;
  background-color: #ddd;
  margin: 0 15px;
}

.font-size-options {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.font-size-label {
  font-size: 16px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 10px;
}

.font-size-options-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.font-size-option {
  font-size: 16px;
  padding: 10px 20px;
  cursor: pointer;
  border: 2px solid transparent;
}

.font-size-option.selected {
  border-color: black;
}

.tip-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}

.tip-action-button {
  position: absolute;
  right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  z-index: 10;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}

.tip-chat-icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.tip-vertical-text {
  font-size: 12px;
  color: #409EFF;
  white-space: nowrap;
  writing-mode: vertical-rl;
  text-align: center;
  line-height: 1.2;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tip-title {
  margin: 10px 0 0 15px !important;
}

</style>
